import { render, staticRenderFns } from "./RelatedProductsTwo.vue?vue&type=template&id=5d173e0a&"
import script from "./RelatedProductsTwo.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d173e0a')) {
      api.createRecord('5d173e0a', component.options)
    } else {
      api.reload('5d173e0a', component.options)
    }
    module.hot.accept("./RelatedProductsTwo.vue?vue&type=template&id=5d173e0a&", function () {
      api.rerender('5d173e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/related/RelatedProductsTwo.vue"
export default component.exports